import { Box, Typography, useTheme } from "@mui/material"
import Image from "next/image"

interface TableComponentProps {
  data: {
    [key: string]: any
  }[]
  priceInfo1: string
  priceInfo2: string
  showSmallSize?: boolean
}

const ClubTable = ({ data, priceInfo1, priceInfo2, showSmallSize = false }: TableComponentProps) => {
  const theme = useTheme()
  const TablefontSize = showSmallSize ? "12px" : "14px"
  return (
    <table>
      <tr style={{ fontSize: TablefontSize }}>
        <th>شرکت طرف قرارداد</th>
        <th>توضیحات</th>
      </tr>

      {data.map((item, index) => (
        <tr
          key={item.company}
          style={
            theme.palette.mode === "dark"
              ? { backgroundColor: index % 2 === 0 ? theme.palette.grey[800] : theme.palette.grey[900] }
              : {}
          }
        >
          <td>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center"
              }}
            >
              <Image src={`${item?.logo}`} alt='' width='25' height='25' style={{ marginLeft: "0.5rem" }} />
              <Typography variant={showSmallSize ? "subtitle2" : "subtitle1"}>{item?.company}</Typography>
            </Box>
          </td>
          <td>
            <div style={{ fontSize: TablefontSize }} dangerouslySetInnerHTML={{ __html: item?.comment }} />
          </td>
        </tr>
      ))}
      {priceInfo1 !== "" && (
        <>
          <tr>
            <td colSpan={2}>
              <Box sx={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
                <Typography variant={showSmallSize ? "h6" : "h5"} color='primary'>
                  هزینه های طرح:
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    p: 1
                  }}
                >
                  <Typography variant={showSmallSize ? "subtitle2" : "subtitle1"} m={1}>
                    {priceInfo1}
                  </Typography>
                  <Typography variant={showSmallSize ? "subtitle2" : "subtitle1"} m={1}>
                    {priceInfo2}
                  </Typography>
                </Box>
              </Box>
            </td>
          </tr>
        </>
      )}
    </table>
  )
}

export default ClubTable
